import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import CounterOne from "../elements/counters/CounterOne";
import Testimonial from "../elements/Testimonial";
import BrandTwo from "../elements/BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";


class About extends Component{
    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='About' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'About'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/4W5A8462.jpg" alt="About Images"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h3 className="title">Who is Dennis?</h3>
                                            <p className="description">
                                                A driving force in Business Transformation and Project Management, Dennis Isiakpona is known for his relentless commitment to strategic change and career excellence. His work empowers organisations to navigate complexity, innovate with confidence, and achieve sustainable growth, while also guiding professionals towards fulfilling and high-impact careers.<br /><br />
                                                
                                                With a reputation as a trusted Tech Futurist and Digital Transformation leader, he has shaped world-class talent and inspired Fortune 500 companies. His visionary leadership, combined with deep industry expertise, consistently pushes boundaries, helping organisations thrive in an ever-evolving business landscape and enabling individuals to reach new heights of excellence.<br /><br />
                                                
                                                A self-described "observer of life's quirks," his approach to work and life is rooted in continuous learning, authenticity, and integrity. He thrives on exceeding expectations, outlearning the competition, and delivering what others consider impossible, all while maintaining a people-centric, strategic, and empathetic coaching style.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <p className="description">
                                                <br /><br />
                                                As the founder of PathFinderX Consulting, a premier tech-driven workforce development firm, he has built a platform that seamlessly integrates technology education, career support, recruitment, and management consulting. Through industry-focused courses and strategic partnerships, PathFinderX empowers talent with in-demand technology skills and connects companies with the best professionals. His keen ability to identify patterns in human behaviour and success has made him a sought-after coach for African talents and the Black diaspora transitioning into tech.<br /><br />

                                                His transformative leadership does not just drive results, it sparks lasting change. Mentees, clients, and colleagues alike credit his influence for unlocking new possibilities and reshaping their career trajectories. His passion for empowerment has turned PathFinderX into a catalyst for professional and organisational success.<br /><br />
                                                
                                                A lifelong learner, Dennis constantly sharpens his expertise in Business and Project Management. He earned an MBA from the University of Nicosia, Cyprus, and an MSc with distinction in Project Management from De Montfort University, United Kingdom. His credentials also include a Change Management Certificate from the International Business Management Institute (IBMI), a Project Management Professional (PMP) certification from the Project Management Institute (PMI), and a Certified Scrum Master credential from the International Scrum Institute.<br /><br />
                                                
                                                Through his work, insights, and leadership, Dennis Isiakpona is redefining what it means to lead, transform, and excel in the digital age.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--7">
                    <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>Whatever path you took to get here, I am really glad you are here because I am here to help you take charge of your career, break past self-doubt, and build a future you are genuinely excited about.<br /><br />

                                Let's make it happen—book a 45-minute clarity call today.</p>
                                <a className="rn-btn btn-white" href="https://calendly.com/dennisoge/clarity-call" target="_blank">Calendly</a>
                            </div>
                        </div>
                        {/* <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div> */}
                    </div>
                </div>
                {/* End Finding Us Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />

            </React.Fragment>
        )
    }
}
export default About